"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _ADD_USER_FLOW = _interopRequireDefault(require("./graphql/ADD_USER_FLOW"));

var _ADD_USER_EMAIL = _interopRequireDefault(require("./graphql/ADD_USER_EMAIL"));

var _INSERT_COMMON_INFO = _interopRequireDefault(require("./graphql/INSERT_COMMON_INFO"));

var _reactHooks = require("@apollo/react-hooks");

var _bluekeelPixel = _interopRequireDefault(require("./pixels/bluekeelPixel"));

var _bluekeelControllers = require("@bit/bluekeel.controllers.helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useTrackingLayer = function useTrackingLayer(tracking, email) {
  var _useState = (0, _react.useState)((0, _bluekeelControllers.checkCookie)('em_sub')),
      _useState2 = _slicedToArray(_useState, 1),
      isDuplicate = _useState2[0];

  var hsid = tracking.hsid,
      pid = tracking.pid,
      oid = tracking.oid,
      eid = tracking.eid,
      sid = tracking.sid,
      uid = tracking.uid,
      vertical = tracking.vertical,
      loan_type = tracking.loan_type,
      debt_type = tracking.debt_type,
      debt_amount = tracking.debt_amount,
      ip_address = tracking.ip_address,
      fname = tracking.fname,
      lname = tracking.lname,
      address = tracking.address,
      city = tracking.city,
      state = tracking.state,
      zip = tracking.zip;

  var _useMutation = (0, _reactHooks.useMutation)(_ADD_USER_FLOW.default, {
    onCompleted: function onCompleted() {
      return console.log('UserFlow posted to Mongo.');
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      addUserFlow = _useMutation2[0];

  var _useMutation3 = (0, _reactHooks.useMutation)(_ADD_USER_EMAIL.default, {
    onCompleted: function onCompleted(data) {
      var submittedEmail = data.addUserEmail.body.email;
      console.log('Email posted to Mongo:', submittedEmail);

      if (submittedEmail && submittedEmail !== '') {
        console.log('Setting submission cookie!');
        (0, _bluekeelControllers.setCookie)('em_sub', submittedEmail, 30);
      }

      ;
    }
  }),
      _useMutation4 = _slicedToArray(_useMutation3, 1),
      addUserEmail = _useMutation4[0];

  var _useMutation5 = (0, _reactHooks.useMutation)(_INSERT_COMMON_INFO.default, {
    onCompleted: function onCompleted() {
      return console.log('CommonInfo posted to CF.');
    }
  }),
      _useMutation6 = _slicedToArray(_useMutation5, 1),
      insertCommonInfo = _useMutation6[0];

  var postToCommonInfo = function postToCommonInfo(emailProp) {
    insertCommonInfo({
      variables: {
        visitor: {
          'hsid': Number(hsid),
          'oid': Number(oid),
          eid: eid,
          uid: uid,
          ip_address: ip_address,
          'sid': Number(sid),
          'email': emailProp,
          fname: fname,
          lname: lname,
          address: address,
          city: city,
          state: state,
          zip: zip
        }
      }
    });
  };

  var postEmailToMongo = function postEmailToMongo(emailProp) {
    if (emailProp && emailProp !== '') {
      addUserEmail({
        variables: {
          clickId: Number(hsid),
          email: emailProp
        }
      });
    }
  };

  var postFlowToMongo = function postFlowToMongo() {
    addUserFlow({
      variables: {
        clickId: Number(hsid),
        flow: {
          'pid': Number(pid),
          vertical: vertical,
          loan_type: loan_type,
          debt_type: debt_type,
          debt_amount: debt_amount
        }
      }
    });
  };

  (0, _react.useEffect)(function () {
    var insertEmail = isDuplicate || email === 'omit' ? '' : email;
    (0, _bluekeelPixel.default)(hsid);
    postToCommonInfo(insertEmail);
    postEmailToMongo(insertEmail);
    postFlowToMongo(); // eslint-disable-next-line
  }, []);
  return;
};

var _default = useTrackingLayer;
exports.default = _default;

//# sourceMappingURL=useTrackingLayer.js.map